module.exports = __webpack_public_path__ + "img/delivery-note.5b90ab8a.svg";